import React from 'react'

export default function ClassiclePivot({item}) {
  return (
     <>
     <tr className="table_rows">
                <td className="boldfont">Daily</td>
                <td className="boldfont">PP</td>
                <td>{item.pp ? item.pp : ""} </td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">S1</td>
                <td>{item.sone ? item.sone : ""} </td>
                <td className="boldfont">R1</td>
                <td>{item.rone ? item.rone : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S2</td>
                <td>{item.stwo ? item.stwo : ""} </td>
                <td className="boldfont">R2</td>
                <td>{item.rtwo ? item.rtwo : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S3</td>
                <td>{item.sthree ? item.sthree : ""} </td>
                <td className="boldfont">R3</td>
                <td>{item.rthree ? item.rthree : ""} </td>
              </tr>

              <tr className="table_rows highlited_row">
                <td className="boldfont">Weekly</td>
                <td className="boldfont">PP</td>
                <td>{item.wpp ? item.wpp : ""} </td>
                <td></td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">S1</td>
                <td>{item.wsone ? item.wsone : ""} </td>
                <td className="boldfont">R1</td>
                <td>{item.wrone ? item.wrone : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S2</td>
                <td> {item.wstwo ? item.wstwo : ""}</td>
                <td className="boldfont">R2</td>
                <td>{item.wrtwo ? item.wrtwo : ""} </td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S3</td>
                <td>{item.wsthree ? item.wsthree : ""} </td>
                <td className="boldfont">R3</td>
                <td>{item.wrthree ? item.wrthree : ""} </td>
              </tr>
              <tr className="table_rows highlited_row">
                <td>Monthly</td>
                <td className="boldfont">PP</td>
                <td>{item.mpp ? item.mpp : ""} </td>
                <td></td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S1</td>
                <td>{item.msone ? item.msone : ""} </td>
                <td className="boldfont">R1</td>
                <td> {item.mrone ? item.mrone : ""}</td>
              </tr>

              <tr className="table_rows">
                <td className="boldfont">S2</td>
                <td>{item.mstwo ? item.mstwo : ""} </td>
                <td className="boldfont">R2</td>
                <td> {item.mrtwo ? item.mrtwo : ""}</td>
              </tr>
              <tr className="table_rows">
                <td className="boldfont">S3</td>
                <td>{item.msthree ? item.msthree : ""} </td>
                <td className="boldfont">R3</td>
                <td> {item.mrthree ? item.mrthree : ""}</td>
              </tr>
              </>
  )
}
